import React, { Component } from 'react';
import { SelectWrapper } from '@cimpress/react-components';
import Select from 'react-select';
import styles from '@cimpress/react-components/lib/Select/styles';
// styles import only required if using react-select ^2.x.x as the selectedSelect

export default class SelectWrapperDemo extends Component {
  state = {
    options: [
      { value: 'one', label: 'One' },
      { value: 'two', label: 'Two' },
      { value: 'three', label: 'Three' },
      { value: 'four', label: 'Four' },
      { value: 'five', label: 'Five' },
      { value: 'six', label: 'Six' },
      { value: 'seven', label: 'Seven' },
      { value: 'eight', label: 'Eight' },
      { value: 'nine', label: 'Nine' },
      { value: 'ten', label: 'Ten' },
    ],
    selectedSingle: undefined,
    selectedMulti: undefined,
  };

  onSingleSelectionChange = selectedSingle => {
    this.setState({ selectedSingle });
  };

  onMultiSelectionChange = selectedMulti => {
    this.setState({ selectedMulti });
  };

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-6">
            <SelectWrapper
              selectedSelect={Select}
              styles={styles}
              label="Select a thing"
              value={this.state.selectedSingle}
              options={this.state.options}
              onChange={this.onSingleSelectionChange}
              helpText="You can select a single thing from here."
            />
          </div>
          <div className="col-md-6">
            <SelectWrapper
              styles={styles}
              selectedSelect={Select}
              label="Select many things"
              value={this.state.selectedMulti}
              options={this.state.options}
              onChange={this.onMultiSelectionChange}
              isMulti
              helpText="You can select multiple things from here."
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <SelectWrapper
              isMulti
              selectedSelect={Select}
              styles={styles}
              label="Select many things"
              value={this.state.selectedMulti}
              options={this.state.options}
              onChange={this.onMultiSelectionChange}
              status="success"
              helpText="You can safely select multiple things from here."
            />
          </div>
          <div className="col-md-4">
            <SelectWrapper
              styles={styles}
              selectedSelect={Select}
              label="Select a thing"
              value={this.state.selectedSingle}
              options={this.state.options}
              onChange={this.onSingleSelectionChange}
              status="warning"
              helpText="You need to cautiously select a thing from here."
            />
          </div>
          <div className="col-md-4">
            <SelectWrapper
              styles={styles}
              selectedSelect={Select}
              label="Select a thing"
              value={this.state.selectedSingle}
              options={this.state.options}
              onChange={this.onSingleSelectionChange}
              status="error"
              helpText="It is dangerous to select anything."
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
